<template>
  <div class="row mb-20">
    <div class="col-md-12">
      <div class="dash-inner-box">
        <div class="dashboard-heading">
          <h1 class="form-heading">Select Infrastructure</h1>
        </div>
        <form id="infraForm">
        <div class="row p10-20">
          <div class="col-md-2" v-for="infraItem in infraList">
            <div class="infraCheck">
              <input type="checkbox" v-bind:id="infraItem.college_infrastructure_enc_id"
                     name="select" v-bind:value="infraItem.infra_name"
                     @click="showInfra($event)" v-model="infraItem.isChecked ? 'checked' : ''">
              <label v-bind:for="infraItem.college_infrastructure_enc_id">
                <div class="infraIcon">
                  <img v-bind:src="infraItem.icon">
                </div>
                <h3>{{ infraItem.infra_name }}</h3>
              </label>
            </div>
          </div>
        </div>
      </form>
      </div>
    </div>
    <div class="col-md-12 margin-top-40">
      <div class="dash-inner-box">
        <div class="dashboard-heading">
          <h1 class="form-heading">Infrastructure Details</h1>
        </div>
        <div class="row p10-20" id="showInfra">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
  name: "Infrastructure",
  data(){
    return{
      infraList: [],
      selectedInfra: [],
    }
  },
  mounted() {
    this.getInfraList();
  },
  created() {
    window.saveInfra = this.saveInfra.bind(this);
    window.charCount = this.charCount.bind(this);
  },
  methods: {
    saveInfra(event) {
      let parElem = event.target.parentElement;
      let btn = event.currentTarget;
      let elem = parElem.querySelector('textarea');
      let infra_description = elem.value.trim();
      let infra_id = elem.getAttribute('data-id');
      let data = new FormData;
      data.append('college_infra_id', infra_id);
      data.append('description', infra_description);
      let self = this;
      console.log(btn)
      btn.innerHTML = '<i class="fas fa-circle-notch fa-spin fa-fw"></i>';
      axios.post(`${this.$parent.url}api/v2/college-profile/add-infra-detail`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              btn.innerHTML = 'Save';
            }else{
              btn.innerHTML = 'Save';
            }
          }
      )

    },
    getInfraList() {
      let t = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/infra-list`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.infraList = response['data']['response']['infrastructure_list'];
              t.getSelectedInfra();
            }
          }
      )
    },
    getSelectedInfra() {
      let t = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/infra-detail-list`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.selectedInfra = response['data']['response']['list'];
              let showInfra = document.getElementById('showInfra');
              let infraForm = document.querySelector('#infraForm');
              for (let i = 0; i < t.selectedInfra.length; i++) {
                let sCheckBox = infraForm.querySelector('#' + t.selectedInfra[i]['college_infrastructure_enc_id']);
                sCheckBox.checked = 'true';
                let sInfra = t.infraList.filter(
                    infraItem => infraItem.college_infrastructure_enc_id == t.selectedInfra[i]['college_infrastructure_enc_id']
                )
                const {icon, college_infrastructure_enc_id, infra_name} = sInfra[0];
                let infraDec = t.selectedInfra[i]['description'];
                let div = document.createElement('div');
                div.innerHTML = t.getTemplate(infra_name, college_infrastructure_enc_id, icon, infraDec);
                showInfra.appendChild(div);
              }
            }
          }
      )
    },
    removeInfra(id) {
      let t = this;
      let data = {college_infra_id: id}
      axios.post(`${this.$parent.url}api/v2/college-profile/remove-infra`, data, {headers: requestHeaders()}).then(
          function (response) {

          }
      )
    },
    getTemplate(elemValue = null, elemId = null, imgPath = null, elemDes = null, loading = null) {
      let infra = `<div class="col-md-6" id="` + elemId + `">
                                <div class="facility-box">
                                  <div class="fIcon">
                                    <img src="` + imgPath + `"><p>` + elemValue + `</p>
                                  </div>
                                  <textarea class="formTextFields" data-id="` + elemId + `"
                                    placeholder="Write ` + elemValue + ` Description" onkeyup="charCount(event)" maxlength="500">${elemDes ? elemDes : ''}</textarea>
                                    <button class="saveInfraBtn" onclick="saveInfra(event)">Save</button>
                                  <p class="charcount"><span id="charText">Maximum Character Limit</span> <span id="cCountNum"> 500</span></p>
                                </div>
                              </div>`;
      return infra;
    },
    charCount(event) {
      let parElem = event.target.parentElement;
      let maxLength = 500;
      let charLength = event.target.value.trim().length;
      let charLeft = maxLength - charLength;
      parElem.querySelector('#cCountNum').innerText = charLeft;
      parElem.querySelector('#charText').innerText = 'Character(s) Left'
    },
    showInfra(event) {
      let clickedElem = event.currentTarget;
      let parElem = clickedElem.parentElement;
      let elemValue = clickedElem.getAttribute('value');
      let elemId = clickedElem.getAttribute('id');
      let imgPath = parElem.querySelector('img').getAttribute('src');
      let showInfra = document.getElementById('showInfra');
      if (event.target.checked) {
        let div = document.createElement('div');
        div.innerHTML = this.getTemplate(elemValue, elemId, imgPath);
        showInfra.appendChild(div);
      } else {
        this.removeInfra(elemId)
        let elemDiv = showInfra.querySelector('#' + elemId);
        elemDiv.remove();
      }
    },
  }
}
</script>

<style scoped>

</style>